import { apiGetSellByProducts } from "api/reportApi";

import { AmountComponent, PriceComponent } from "components/Table/CellComponents";

const sellByProductsColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        size: "2",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "دسته بندی",
        key: "Category",
        size: "3",
        searchType: "autocomplete",
        filterParams: {
            column: "Category",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "نام",
        key: "title",
        size: "5",
        navigateKey: (item: any) => item.productId,
        navigate: "/reports/productsAccountCard?productId=",
        // disableSearch: true,
        filterParams: {
            column: "title",
            columnType: "string",
        },
    },
    {
        name: "کد کالا",
        key: "code",
        size: "2",
        filterParams: {
            column: "code",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "تعداد فروش",
        key: "saleQuantity",
        size: "2",
        Component: AmountComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleQuantity",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "تخفیف فروش",
        key: "saleDiscount",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleDiscount",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مالیات فروش",
        key: "saleTax",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleTax",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مبلغ فروش",
        key: "saleAmount",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleAmount",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "تعداد برگشت",
        key: "saleReturnsQuantity",
        size: "2",
        Component: AmountComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleReturnsQuantity",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مبلغ برگشت",
        key: "saleReturnsAmount",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleReturnsAmount",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "میانگین قیمت",
        key: "average",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "average",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مبلغ تخفیف برگشتی",
        key: "saleReturnsDiscount",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleReturnsDiscount",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مبلغ مالیات برگشتی",
        key: "saleReturnsTax",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleReturnsTax",
            columnType: "number",
        },
        // disableSearch: true,
    },
];

export const SellByProductsIndexData = [
    {
        key: "sellByProducts",
        label: "فروش به تفکیک کالا",
        pluralLabel: "فروش به تفکیک کالا",
        title: "فروش به تفکیک کالا",
        withDateFilter: true,
        pageTitle: "فروش به تفکیک کالا",
        // pageDescription: "نمایش کالا و خدمات کسب و کار",
        tableColumns: sellByProductsColumns,
        disableSearch: false,
        actions: {
            back: {},
            fetch: apiGetSellByProducts,
            // excel: {},
        },
    },
];
